import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import { ListingSectionObservable } from '../ListingSection';

import openLandlordPoliciesSimplifiedModal from './LandlordPoliciesSimplifiedModal';

import './LandlordPoliciesSimplified.scss';

const CHAR_LIMIT = 300;

const stripHtml = html =>
  html
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();

const LandlordPoliciesSimplified = ({ landlordPolicies }) => {
  const plainText = stripHtml(landlordPolicies);
  const isLong = plainText.length > CHAR_LIMIT;
  const previewText = isLong
    ? `${plainText.slice(0, CHAR_LIMIT)}...`
    : plainText;

  return (
    <ListingSectionObservable
      section="landlordPolicies"
      className="landlord-policies-simplified"
    >
      <ListingTitle role="tertiary">
        {trans('property_show.title.landlord_policies')}
      </ListingTitle>
      <p className="landlord-policies-simplified__preview">{previewText}</p>
      {isLong && (
        <Button
          type="button"
          color="link"
          className="landlord-policies-simplified__view-more"
          onClick={() =>
            openLandlordPoliciesSimplifiedModal({
              landlordPolicies,
              fullscreenOnMobile: true
            })
          }
        >
          {trans('listing.simplification.bottom.cancellation.learn-more')}
        </Button>
      )}
    </ListingSectionObservable>
  );
};

LandlordPoliciesSimplified.propTypes = {
  landlordPolicies: PropTypes.string.isRequired
};

export default LandlordPoliciesSimplified;
